import { useState } from "react";
import axios from "axios";

const API_BASE_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const API = `${API_BASE_URL}/api`;

export default function WaitlistForm({ variant = "default" }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("loading");
    try {
      const res = await axios.post(`${API}/waitlist`, { email });
      setStatus("success");
      setMessage(res.data.message);
      setEmail("");
    } catch (err) {
      setStatus("error");
      setMessage(err.response?.data?.detail || "Something went wrong. Try again.");
    }
  };

  const isInline = variant === "inline";

  return (
    <form
      onSubmit={handleSubmit}
      data-testid="waitlist-form"
      className={`flex ${isInline ? "flex-row" : "flex-col sm:flex-row"} gap-3 w-full max-w-md`}
    >
      <div className="flex-1 relative">
        <input
          type="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (status !== "idle") setStatus("idle");
          }}
          placeholder="you@company.com"
          data-testid="waitlist-email-input"
          className="w-full px-4 py-3 rounded-lg text-sm outline-none transition-all duration-200"
          style={{
            background: "rgba(255,255,255,0.05)",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#fff",
            fontFamily: "'Inter', sans-serif",
          }}
          onFocus={(e) => (e.target.style.borderColor = "rgba(255,255,255,0.3)")}
          onBlur={(e) => (e.target.style.borderColor = "rgba(255,255,255,0.12)")}
        />
      </div>
      <button
        type="submit"
        disabled={status === "loading"}
        data-testid="waitlist-submit-btn"
        className="px-6 py-3 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap"
        style={{
          background: status === "success" ? "#10B981" : "#fff",
          color: status === "success" ? "#fff" : "#000",
          opacity: status === "loading" ? 0.7 : 1,
        }}
      >
        {status === "loading"
          ? "Joining..."
          : status === "success"
          ? "You're in!"
          : "Request Early Access"}
      </button>
      {(status === "success" || status === "error") && (
        <p
          data-testid="waitlist-message"
          className="text-sm absolute mt-14"
          style={{ color: status === "success" ? "#10B981" : "#EF4444" }}
        >
          {message}
        </p>
      )}
    </form>
  );
}
